import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
} from 'owa-attachment-link-common';

export type CommentText =
    | typeof COMPOSE_ONLY_ATTACHMENT_CONTENT_START
    | typeof COMPOSE_ONLY_ATTACHMENT_CONTENT_END;

export interface ReactCommentProps {
    text: CommentText;
}

export function ReactComment(props: ReactCommentProps) {
    const divRef = React.useRef<HTMLDivElement>();
    React.useEffect(() => {
        const element = divRef.current;
        ReactDOM.unmountComponentAtNode(element);
        /* As `this.props.text` is only the constants
         * we define and is not dependent on user input
         * so there is no risk of cross-site scripting attack.
         */
        // tslint:disable-next-line:no-inner-html
        element.outerHTML = createComment();
    }, []);
    const createComment = () => {
        return `<!--${props.text}-->`;
    };
    return <div ref={divRef} />;
}
